/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ra_band_fairly_difficult = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fairly difficult`)
};

const es_ra_band_fairly_difficult = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bastante difícil`)
};

const de_ra_band_fairly_difficult = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziemlich schwer`)
};

const nl_ra_band_fairly_difficult = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamelijk moeilijk`)
};

const fr_ra_band_fairly_difficult = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assez difficile`)
};

const it_ra_band_fairly_difficult = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbastanza difficile`)
};

const pt_br2_ra_band_fairly_difficult = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Razoavelmente difícil`)
};

const pt_ra_band_fairly_difficult = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relativamente difícil`)
};

const ja_ra_band_fairly_difficult = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`比較的難しい`)
};

const zh_ra_band_fairly_difficult = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`较难`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ra_band_fairly_difficult = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ra_band_fairly_difficult(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ra_band_fairly_difficult", locale)
	if (locale === "en") return en_ra_band_fairly_difficult(inputs)
	if (locale === "es") return es_ra_band_fairly_difficult(inputs)
	if (locale === "de") return de_ra_band_fairly_difficult(inputs)
	if (locale === "nl") return nl_ra_band_fairly_difficult(inputs)
	if (locale === "fr") return fr_ra_band_fairly_difficult(inputs)
	if (locale === "it") return it_ra_band_fairly_difficult(inputs)
	if (locale === "pt-BR") return pt_br2_ra_band_fairly_difficult(inputs)
	if (locale === "pt") return pt_ra_band_fairly_difficult(inputs)
	if (locale === "ja") return ja_ra_band_fairly_difficult(inputs)
	return zh_ra_band_fairly_difficult(inputs)
};